<div class="sup-header">
  <ng-content select="[title]"></ng-content>
  <div class="button-container hgap-3">
    <ng-content select="[buttons]"></ng-content>
  </div>
</div>
